import { useState, useEffect, useRef } from "react";
import JobBar from "./JobBar";
import JobContainer from "./JobContainer";
import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useJobs } from "../jobsContext";
import { useUserData } from "../UserDataContext";
import {
  getFirestore,
  doc,
  query,
  updateDoc,
  getDoc,
  getDocs,
  deleteDoc,
  collection,
  setDoc,
  where,
} from "firebase/firestore";
import { db, auth } from "../firebase";
import { useLocation } from "react-router-dom";

const JobsContainer = (props) => {
  const {
    jobs,
    loading,
    lastVisibleDoc,
    selectedJob,
    setSelectedJob,
    showFavoritesOnly,
    setShowFavoritesOnly,
    showUSOnly,
    showRemoteOnly,
    selectedTags,
    setSelectedTags,
  } = useJobs();
  const [showTags, setShowTags] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [filters, setFilters] = useState([]);
  const [results, setResults] = useState([]);
  const location = useLocation();
  const [urlJob, setUrlJob] = useState(null);
  const prevResultsRef = useRef([]);
  const hashCode = (s) =>
    s.split("").reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0);

  const [lastFilteredDoc, setLastFilteredDoc] = useState(null);
  const { userData, user } = useUserData();

  const corsProxy = "https://proxy.cors.sh/";
  const apiKey = "temp_fcfb59a062cf4f32cc0fc83835df8de8";

  const updateJobInFirebase = async (jobId, updatedData) => {
    const jobRef = doc(db, "Jobs", jobId);
    await updateDoc(jobRef, updatedData);
  };

  const fetchJobById = async (jobId) => {
    const jobRef = doc(db, "Jobs", jobId);
    const jobDoc = await getDoc(jobRef);
    if (jobDoc.exists()) {
      return { id: jobId, ...jobDoc.data() };
    } else {
      return null;
    }
  };

  const checkUrlForJobParam = async () => {
    const urlParams = new URLSearchParams(location.search);
    const jobId = urlParams.get("job");
    if (jobId) {
      const job = await fetchJobById(jobId);
      if (job) {
        setUrlJob(job);
        setSelectedJob(job);
      }
    }
  };

  useEffect(() => {
    checkUrlForJobParam();
  }, []);

  const fetchWithRetry = async (url, retries = 1) => {
    try {
      const response = await fetch(url, {
        headers: {
          "x-cors-api-key": apiKey,
          "User-Agent":
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/88.0.4324.190 Safari/537.36",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response;
    } catch (error) {
      if (retries > 0) {
        console.log(`Retrying... ${retries} attempts left`);
        await sleep(1000);
        return fetchWithRetry(url, retries - 1);
      } else {
        throw error;
      }
    }
  };

  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };

  const scrapeApplicationLink = async (url) => {
    try {
      const response = await fetch(`${url}`);
      const html = await response.text();

      // Find job type
      const jobTypeRegex =
        /<h3 class="text-sm font-medium text-gray-500">Job type<\/h3>\s*<p class="text-gray-900">(.*?)<\/p>/;
      const jobTypeMatch = html.match(jobTypeRegex);
      const jobType = jobTypeMatch ? jobTypeMatch[1] : "Unknown";

      // Find skills under the "Skills" section
      const skills = [];
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const skillsSection = Array.from(
        doc.querySelectorAll("h3.text-sm.font-medium.text-gray-500")
      ).find((element) => element.textContent.trim() === "Skills");
      if (skillsSection && skillsSection.nextElementSibling) {
        const skillElements =
          skillsSection.nextElementSibling.querySelectorAll("a span");
        skillElements.forEach((element) => {
          skills.push(element.textContent.trim());
        });
      }

      return { jobType, skills };
    } catch (error) {
      console.error("Error scraping application link:", error);
      return { jobType: "Unknown", skills: [] };
    }
  };

  const testServerlessFunction = async () => {
    if (results.length > 0) {
      const topResult = results[0];
      const response = await fetch(
        "https://app.wranglejobs.com/api/scrape-further-info",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            job: topResult,
            url: topResult.guid,
          }),
        }
      );

      const responseData = await response.json();
      console.log("Serverless function response:", responseData);
    }
  };

  const deleteJobFromFirebase = async (jobId) => {
    const jobRef = doc(db, "Jobs", jobId);
    console.log(jobRef);
    //await deleteDoc(jobRef);
  };

  const fetchResults = async () => {
    const chunkSize = 25;
    const totalChunks = Math.ceil(results.length / chunkSize);
    const hashCode = (s) =>
      s.split("").reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0);

    for (let i = 0; i < totalChunks; i++) {
      const start = i * chunkSize;
      const end = start + chunkSize;
      const chunk = results.slice(start, end);

      const fetchPromises = chunk.map(async (job) => {
        if (
          !job.type ||
          !job.skills ||
          job.skills.length === 0 ||
          job.type === "Unknown"
        ) {
          try {
            const response = await fetch(
              "https://app.wranglejobs.com/api/scrape-further-info",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  job: job,
                  url: job.guid,
                }),
              }
            );

            const updatedJob = await response.json();

            if (updatedJob.type && updatedJob.type !== "Unknown") {
              const hashCode = (s) =>
                s
                  .split("")
                  .reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0);
              await updateJobInFirebase(hashCode(job.guid).toString(), {
                skills: updatedJob.skills,
                type: updatedJob.type,
              });

              console.log(updatedJob);
              return updatedJob;
            } else {
              await deleteJobFromFirebase(hashCode(job.guid).toString());
              console.log(`Deleted job with GUID: ${job.guid}`);
              return null;
            }
          } catch (error) {
            console.error("Error fetching job details:", error);
            return {
              ...job,
              skills: job.skills || [],
              type: job.type || "Unknown",
            };
          }
        } else {
          return job;
        }
      });

      const updatedResultsChunk = await Promise.all(fetchPromises);
      console.log(updatedResultsChunk);
    }
  };

  const getSkillColors = (type) => {
    switch (type ? type : "") {
      case "engineering":
        return { textColor: "#16a34a", bgColor: "bg-green-50" };
      case "sales":
        return { textColor: "#2563eb", bgColor: "bg-blue-50" };
      case "marketing":
        return { textColor: "#9333ea", bgColor: "bg-purple-50" };
      case "product":
        return { textColor: "#db2777", bgColor: "bg-pink-50" };
      case "design":
        return { textColor: "#dc2626", bgColor: "bg-red-50" };
      case "support":
        return { textColor: "#ea580c", bgColor: "bg-orange-50" };
      case "operations":
        return { textColor: "#4f46e5", bgColor: "bg-indigo-50" };
      case "data":
        return { textColor: "#ca8a04", bgColor: "bg-yellow-50" };
      case "finance":
        return { textColor: "#0d9488", bgColor: "bg-teal-50" };
      case "management":
        return { textColor: "#4b5563", bgColor: "bg-gray-100" };
      default:
        return { textColor: "#808080", bgColor: "#F0F0F0" };
    }
  };

  const getTypeColors = (type) => {
    switch (type ? type : "") {
      case "Full Time":
        return { textColor: "#4C6EAF", bgColor: "#E6EEF6" };
      case "Part Time":
        return { textColor: "#6BA292", bgColor: "#E6F4F1" };
      case "Contractor":
        return { textColor: "#EEBB39", bgColor: "#FFF6E6" };
      case "Temporary":
        return { textColor: "#A267AC", bgColor: "#F4E6F8" };
      case "Intern":
        return { textColor: "#D2691E", bgColor: "#F4EAE6" };
      case "Volunteer":
        return { textColor: "#C8385A", bgColor: "#FCE6EF" };
      case "Other":
        return { textColor: "#8B4513", bgColor: "#FFF5E6" };
      default:
        return { textColor: "#808080", bgColor: "#F0F0F0" };
    }
  };

  const generateTags = (job) => {
    const tags = [];

    /*
    if (!(job.locationRestrictions == "United States")) {
      tags.push({
        text: "International",
        textColor: "#574EFA",
        bgColor: "#F2F2FF",
        icon: (
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
              stroke="#574EFA"
              strokeWidth="1.5"
            />
            <path
              d="M20 5.69899C19.0653 5.76636 17.8681 6.12824 17.0379 7.20277C15.5385 9.14361 14.039 9.30556 13.0394 8.65861C11.5399 7.6882 12.8 6.11636 11.0401 5.26215C9.89313 4.70542 9.73321 3.19045 10.3716 2"
              stroke="#574EFA"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
            <path
              d="M2 11C2.7625 11.6621 3.83046 12.2682 5.08874 12.2682C7.68843 12.2682 8.20837 12.7649 8.20837 14.7518C8.20837 16.7387 8.20837 16.7387 8.72831 18.2288C9.06651 19.1981 9.18472 20.1674 8.5106 21"
              stroke="#574EFA"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
            <path
              d="M22 13.4523C21.1129 12.9411 20 12.7308 18.8734 13.5405C16.7177 15.0898 15.2314 13.806 14.5619 15.0889C13.5765 16.9775 17.0957 17.5711 14 22"
              stroke="#574EFA"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
          </svg>
        ),
      });
    }
    */

    if (job.type && job.type != "Unknown") {
      tags.push({
        text: job.type,
        ...getTypeColors(job.type),
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.57956 8.62505C2.50886 8.03528 2.47351 7.74039 2.52323 7.499C2.6651 6.81015 3.27111 6.25159 4.07871 6.06529C4.36172 6 4.717 6 5.42757 6H18.5724C19.283 6 19.6383 6 19.9213 6.06529C20.7289 6.25159 21.3349 6.81015 21.4768 7.499C21.5265 7.74039 21.4911 8.03528 21.4204 8.62505C21.2584 9.97669 20.4991 10.716 19.0512 11.1423L14.88 12.3703C13.4541 12.7901 12.7411 13 12 13C11.2589 13 10.5459 12.7901 9.11996 12.3703L4.94882 11.1423C3.50094 10.7161 2.7416 9.97669 2.57956 8.62505Z"
              stroke={getTypeColors(job.type)["textColor"]}
              strokeWidth="1.5"
            />
            <path
              d="M3.46283 10.5L3.26658 12.7757C2.91481 16.855 2.73892 18.8947 3.86734 20.1974C4.99576 21.5 6.93851 21.5 10.824 21.5H13.176C17.0615 21.5 19.0042 21.5 20.1327 20.1974C21.2611 18.8947 21.0852 16.855 20.7334 12.7757L20.5372 10.5"
              stroke={getTypeColors(job.type)["textColor"]}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M15.5 5.5L15.4227 5.23509C15.0377 3.91505 14.8452 3.25503 14.3869 2.87752C13.9286 2.5 13.3199 2.5 12.1023 2.5H11.8977C10.6801 2.5 10.0714 2.5 9.61309 2.87752C9.15478 3.25503 8.96228 3.91505 8.57727 5.23509L8.5 5.5"
              stroke={getTypeColors(job.type)["textColor"]}
              strokeWidth="1.5"
            />
          </svg>
        ),
      });
    }

    if (job.skills && job.categories) {
      tags.push({
        text: job.skills[0],
        ...getSkillColors(job.categories[0]),
        /*icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 17C10.3264 17 8.86971 18.265 8.11766 20.1312C7.75846 21.0225 8.27389 22 8.95877 22H15.0412C15.7261 22 16.2415 21.0225 15.8823 20.1312C15.1303 18.265 13.6736 17 12 17Z"
              stroke={getSkillColors(job.seniority)["textColor"]}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M18.5 5H19.7022C20.9031 5 21.5035 5 21.8168 5.37736C22.13 5.75472 21.9998 6.32113 21.7393 7.45395L21.3485 9.15307C20.7609 11.7086 18.6109 13.6088 16 14"
              stroke={getSkillColors(job.seniority)["textColor"]}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M5.5 5H4.29779C3.09692 5 2.49649 5 2.18324 5.37736C1.86999 5.75472 2.00024 6.32113 2.26075 7.45395L2.65148 9.15307C3.23914 11.7086 5.38912 13.6088 8 14"
              stroke={getSkillColors(job.seniority)["textColor"]}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 17C15.0208 17 17.565 12.3379 18.3297 5.99089C18.5412 4.23558 18.647 3.35793 18.0868 2.67896C17.5267 2 16.6223 2 14.8134 2H9.18658C7.37775 2 6.47333 2 5.91317 2.67896C5.35301 3.35793 5.45875 4.23558 5.67025 5.99089C6.435 12.3379 8.97923 17 12 17Z"
              stroke={getSkillColors(job.seniority)["textColor"]}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        ),
        */
      });
    }
    if (
      job.source == "indeed" &&
      job.description.toLowerCase().includes("benefits")
    ) {
      tags.push({
        text: "Benefits",
        textColor: "#EEA977",
        bgColor: "#FFEEE2",
      });
    }
    {
      /*
    if (new Date().getTime() / 1000 - job.pubDate < 7 * 24 * 60 * 60) {
      tags.push({
        text: "New",
        textColor: "#5BC68D",
        bgColor: "#E6FBF0",
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5143 2.09327C11.8265 1.96891 12.1735 1.96891 12.4857 2.09327C13.4921 2.49406 13.6887 4.03744 14.8762 4.12336C15.7124 4.18386 16.533 3.48677 17.3721 3.69574C17.7105 3.78003 18.0028 3.99579 18.186 4.29657C18.7472 5.21824 18.0229 6.57292 18.9383 7.33768C19.5743 7.86877 20.6251 7.80004 21.178 8.4511C21.4108 8.72534 21.5252 9.08303 21.4953 9.4437C21.4068 10.5166 20.0389 11.1876 20.3395 12.3439C20.5475 13.1443 21.4253 13.707 21.4953 14.5563C21.5252 14.917 21.4108 15.2747 21.178 15.5489C20.4832 16.3669 18.9808 16.0975 18.5476 17.2062C18.2434 17.9844 18.634 18.9677 18.186 19.7034C18.0028 20.0042 17.7105 20.22 17.3721 20.3043C16.3302 20.5637 15.2727 19.4445 14.2701 20.0758C13.5543 20.5264 13.2978 21.5835 12.4857 21.9067C12.1735 22.0311 11.8265 22.0311 11.5143 21.9067C10.7022 21.5835 10.4457 20.5264 9.72989 20.0758C8.73971 19.4524 7.65213 20.5593 6.62791 20.3043C6.28947 20.22 5.9972 20.0042 5.81405 19.7034C5.25286 18.7818 5.97704 17.427 5.0617 16.6623C4.42582 16.1312 3.37494 16.2 2.82204 15.5489C2.58921 15.2747 2.47484 14.917 2.50465 14.5563C2.57485 13.707 3.4524 13.1443 3.6605 12.3439C3.95808 11.1997 2.59204 10.5009 2.50465 9.4437C2.47484 9.08303 2.58921 8.72534 2.82204 8.4511C3.51676 7.63284 5.01899 7.90253 5.45238 6.79383C5.75662 6.0156 5.36608 5.03227 5.81405 4.29657C5.9972 3.99579 6.28947 3.78003 6.62791 3.69574C7.46705 3.48677 8.28757 4.18387 9.12378 4.12336C10.3113 4.03746 10.5079 2.49406 11.5143 2.09327Z"
              stroke="#5BC68D"
              strokeWidth="1.5"
              strokeLinejoin="round"
            />
            <path
              d="M9 13.3333C9 13.3333 9.875 13.3333 10.75 15C10.75 15 13.5294 10.8333 16 10"
              stroke="#5BC68D"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
      });
    }
  */
    }
    if (
      ["ashbyhq.com", "workable.com", "lever.co", "greenhouse.io"].some(
        (domain) => job.applyNowLink && job.applyNowLink.includes(domain)
      )
    ) {
      tags.push({
        text: "Easy Apply",
        textColor: "#5BC68D",
        bgColor: "#E6FFF2",
        icon: (
          <svg
            width="22"
            height="28"
            viewBox="0 0 35 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.143 11.6932L16.1239 19.3405C16.1222 20.0324 16.7156 20.576 17.4047 20.5136L24.5996 19.8629C26.7963 19.6643 28.4524 17.7796 28.3671 15.5756C28.2915 13.6231 26.8622 11.9887 24.9372 11.6535L17.694 10.3923C16.8855 10.2515 16.1451 10.8726 16.143 11.6932Z"
              fill="#4FA678"
            />
            <path
              d="M28.3908 16.6433L28.3626 15.9151C27.94 13.8637 24.2966 11.5505 8.32503 10.7843C7.28147 10.7343 6.44235 9.89797 6.40149 8.85401C6.29608 6.16083 6.20711 3.91493 6.13514 2.06589C6.09109 0.934249 6.99954 -0.00972833 8.13175 0.015548C20.5479 0.292719 27.6572 3.28342 27.9642 5.6516L28.3626 15.9151C28.4136 16.1627 28.4177 16.4065 28.3908 16.6433Z"
              fill="#5BC68D"
            />
            <path
              d="M12.3804 23.3791L12.3995 15.7318C12.4013 15.0399 11.8078 14.4963 11.1187 14.5586L3.92387 15.2093C1.72715 15.408 0.0710434 17.2926 0.156375 19.4967C0.231968 21.4492 1.66125 23.0836 3.58626 23.4188L10.8295 24.68C11.6379 24.8208 12.3783 24.1997 12.3804 23.3791Z"
              fill="#4FA678"
            />
            <path
              d="M0.13259 18.4289L0.160853 19.1572C0.583448 21.2086 4.22686 23.5217 20.1984 24.2879C21.242 24.338 22.0811 25.1743 22.1219 26.2183C22.2274 28.9114 22.3163 31.1573 22.3883 33.0064C22.4324 34.138 21.5239 35.082 20.3917 35.0567C7.97559 34.7795 0.866285 31.7888 0.559203 29.4207L0.160853 19.1572C0.109844 18.9096 0.105763 18.6658 0.13259 18.4289Z"
              fill="#5BC68D"
            />
          </svg>
        ),
      });
    }
    if (job.source == "indeed") {
      tags.push({
        text: "",
        textColor: "#5BC68D",
        bgColor: "#E2EDFF",
        icon: (
          <svg
            width="100"
            height="20"
            viewBox="0 0 1487 401"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1472.21 71.4993C1467.01 65.5993 1460.01 62.6993 1450.71 62.6993C1441.41 62.6993 1434.11 65.7993 1429.01 72.2993C1424.01 78.5993 1421.41 87.9993 1421.41 100.099V188.899C1409.81 176.399 1397.81 167.499 1385.51 161.499C1377.91 157.799 1368.91 155.099 1358.81 153.799C1352.91 153.099 1347.01 152.699 1340.41 152.699C1309.81 152.699 1285.01 163.199 1266.01 184.399C1247.21 205.399 1237.81 234.699 1237.81 272.199C1237.81 289.899 1240.21 306.499 1245.01 321.699C1249.81 336.799 1256.61 350.099 1265.81 361.499C1275.01 372.699 1286.11 381.399 1298.61 387.699C1311.11 393.799 1324.81 396.899 1339.71 396.899C1346.51 396.899 1353.01 396.299 1358.91 395.199C1363.01 394.599 1366.61 393.499 1370.51 392.399C1379.91 389.299 1388.71 384.799 1396.71 379.099C1405.01 373.199 1413.11 365.699 1421.41 356.399V362.299C1421.41 373.399 1424.21 381.799 1429.71 387.899C1435.41 393.799 1442.41 396.899 1450.71 396.899C1459.41 396.899 1466.41 393.999 1471.71 388.399C1477.01 382.499 1480.01 373.999 1480.01 362.399V96.8993C1479.71 85.8993 1477.21 77.1993 1472.21 71.4993ZM1409.91 316.599C1404.61 327.799 1397.21 336.299 1388.51 341.799C1379.51 347.299 1369.71 349.899 1358.81 349.899H1358.61C1347.71 349.899 1338.01 346.999 1328.91 341.399C1319.91 335.499 1312.71 326.999 1307.51 315.599C1302.31 304.199 1299.81 290.199 1299.81 273.999C1299.81 258.499 1302.21 244.899 1307.21 233.499C1312.01 221.899 1319.01 212.899 1327.81 206.599C1336.81 200.199 1346.81 197.199 1358.21 197.199H1358.81C1369.51 197.199 1379.21 200.299 1388.31 206.399C1397.31 212.499 1404.51 221.299 1409.81 232.699C1415.11 244.099 1417.71 258.099 1417.71 273.999C1417.91 290.999 1415.31 305.199 1409.91 316.599ZM1215.51 319.199C1211.61 315.899 1206.51 314.199 1200.01 314.199C1194.11 314.199 1189.91 315.699 1186.61 318.099C1178.91 325.099 1172.61 330.799 1167.81 334.899C1163.01 338.799 1157.71 342.599 1151.81 346.299C1146.31 349.799 1140.21 352.599 1134.11 353.999C1127.81 355.699 1121.21 356.599 1113.81 356.599C1112.11 356.599 1110.71 356.599 1109.21 356.399C1100.01 355.799 1091.31 353.299 1083.61 348.699C1074.41 343.399 1067.21 335.599 1061.51 325.499C1056.21 314.999 1053.21 302.799 1053.01 289.199H1174.01C1190.21 289.199 1202.71 286.799 1211.61 282.599C1220.61 277.999 1225.01 268.199 1225.01 253.099C1225.01 236.699 1220.61 220.699 1211.91 204.999C1203.21 189.299 1190.51 176.499 1173.01 166.699C1155.71 156.799 1135.11 151.999 1110.91 151.999H1109.11C1091.21 152.199 1074.81 155.099 1060.31 160.699C1045.01 166.599 1032.31 174.899 1021.61 185.599C1011.51 196.499 1003.41 209.499 998.006 224.799C992.606 240.099 989.706 256.699 989.706 274.299C989.706 312.099 1000.81 341.699 1022.71 363.799C1043.51 384.599 1072.21 395.699 1108.91 396.799C1110.91 396.999 1113.11 396.999 1115.31 396.999C1132.41 396.999 1147.91 394.799 1161.31 390.399C1174.71 385.999 1185.81 380.499 1194.61 373.799C1203.41 366.999 1210.11 359.999 1214.31 352.799C1218.71 345.599 1220.91 339.199 1220.91 333.799C1221.51 327.299 1219.51 322.399 1215.51 319.199ZM1071.41 209.099C1081.21 198.799 1093.91 193.599 1109.31 193.599H1109.51C1125.51 193.599 1138.61 198.599 1148.41 208.699C1158.21 218.799 1164.11 234.299 1165.31 254.899H1053.31C1055.41 234.699 1061.31 219.399 1071.41 209.099ZM952.706 314.099C946.606 314.099 942.406 315.599 939.106 317.999C931.506 324.999 925.106 330.699 920.306 334.799C915.506 338.699 910.406 342.499 904.506 346.199C898.806 349.699 892.906 352.499 886.606 353.899C880.506 355.599 873.706 356.499 866.306 356.499C864.606 356.499 863.206 356.499 861.706 356.299C852.506 355.699 843.806 353.199 836.106 348.599C827.106 343.299 819.706 335.499 814.406 325.399C808.706 314.899 805.906 302.699 805.706 289.099H926.506C942.506 289.099 955.006 286.699 964.106 282.499C972.906 277.899 977.406 268.099 977.406 252.999C977.406 236.599 973.206 220.599 964.506 204.899C955.806 189.199 943.006 176.399 925.606 166.599C908.306 156.699 887.506 151.899 863.506 151.899H861.506C843.606 152.099 827.406 154.999 812.706 160.599C797.406 166.499 784.706 174.799 774.206 185.499C763.906 196.399 755.806 209.399 750.406 224.699C744.906 239.999 742.106 256.599 742.106 274.199C742.106 311.999 753.306 341.599 775.306 363.699C796.106 384.499 824.706 395.599 861.306 396.699C863.506 396.899 865.506 396.899 867.706 396.899C885.006 396.899 900.306 394.699 913.706 390.299C927.106 385.899 938.206 380.399 946.906 373.699C955.906 366.899 962.406 359.899 966.806 352.699C971.206 345.499 973.406 339.099 973.406 333.699C973.406 327.599 971.406 322.799 967.506 319.499C964.106 315.699 958.706 314.099 952.706 314.099ZM823.706 209.099C833.506 198.799 846.206 193.599 861.606 193.599H861.806C877.806 193.599 890.906 198.599 900.706 208.699C910.606 218.799 916.406 234.299 917.806 254.899H805.706C807.906 234.699 814.006 219.399 823.706 209.099ZM134.906 356.599V213.099C139.106 213.499 143.206 213.699 147.206 213.699C167.306 213.699 186.106 208.399 202.106 199.199V356.699C202.106 370.099 199.006 380.099 192.706 386.699C186.406 393.299 178.306 396.599 168.206 396.599C158.406 396.599 150.506 393.299 144.306 386.499C138.306 379.599 134.906 369.899 134.906 356.599ZM716.606 71.4993C711.406 65.5993 704.306 62.6993 695.206 62.6993C685.806 62.6993 678.606 65.7993 673.506 72.2993C668.306 78.5993 665.906 87.9993 665.906 100.099V188.899C654.306 176.399 642.306 167.499 630.006 161.499C622.306 157.799 613.406 155.099 603.506 153.799C597.806 153.099 591.706 152.699 585.106 152.699C554.506 152.699 529.506 163.199 510.706 184.399C491.906 205.399 482.506 234.699 482.506 272.199C482.506 289.899 484.906 306.499 489.506 321.699C494.306 336.799 501.306 350.099 510.506 361.499C519.706 372.699 530.806 381.399 543.306 387.699C556.006 393.799 569.506 396.899 584.406 396.899C591.006 396.899 597.506 396.299 603.606 395.199C607.706 394.599 611.306 393.499 615.206 392.399C624.606 389.299 633.406 384.799 641.406 379.099C649.706 373.199 657.606 365.699 666.106 356.399V362.299C666.106 373.399 668.906 381.799 674.406 387.899C679.706 393.799 687.106 396.899 695.406 396.899C703.706 396.899 710.906 393.999 716.206 388.399C721.506 382.499 724.106 373.999 724.106 362.399V96.8993C723.906 85.8993 721.506 77.1993 716.606 71.4993ZM654.506 316.599C649.206 327.799 641.806 336.299 633.006 341.799C624.206 347.299 614.206 349.899 603.506 349.899H603.306C592.406 349.899 582.706 346.999 573.606 341.399C564.406 335.499 557.406 326.999 552.206 315.599C547.006 304.199 544.506 290.199 544.506 273.999C544.506 258.499 546.906 244.899 551.706 233.499C556.706 221.899 563.506 212.899 572.506 206.599C581.306 200.199 591.506 197.199 602.706 197.199H603.406C614.106 197.199 623.806 200.299 632.706 206.399C641.906 212.499 649.106 221.299 654.406 232.699C659.606 244.099 662.306 258.099 662.306 273.999C662.406 290.999 659.606 305.199 654.506 316.599ZM300.906 185.299V192.699C312.006 178.699 323.706 168.599 336.406 161.899C349.506 155.499 364.206 152.099 381.006 152.099C397.206 152.099 411.806 155.599 424.606 162.399C437.506 169.199 446.906 178.999 453.106 191.699C457.306 199.099 459.906 207.199 461.006 215.599C462.106 223.899 462.806 234.899 462.806 248.199V359.799C462.806 371.999 459.906 380.999 454.106 387.099C448.606 393.399 441.006 396.499 432.006 396.499C422.806 396.499 415.406 393.399 409.506 386.899C403.606 380.599 400.806 371.599 400.806 359.799V259.799C400.806 239.899 398.006 224.799 392.306 214.299C386.806 203.799 375.406 198.499 358.406 198.499C347.306 198.499 337.406 201.799 328.406 208.099C319.406 214.499 312.606 223.199 308.306 234.599C305.406 243.599 303.906 260.199 303.906 284.899V359.899C303.906 372.199 301.006 381.099 295.106 387.299C289.206 393.399 281.806 396.499 272.606 396.499C263.606 396.499 256.406 393.399 250.506 386.899C244.606 380.599 241.806 371.599 241.806 359.799V186.299C241.806 174.899 244.406 166.199 249.506 160.699C254.506 154.999 261.506 151.999 270.506 151.999C275.806 151.999 280.606 153.099 285.006 155.699C289.406 158.299 292.906 161.999 295.706 166.899C299.806 172.299 300.906 178.299 300.906 185.299ZM135.306 12.7993C176.906 -1.80069 224.506 -1.00069 260.006 28.9993C266.606 35.0993 274.206 42.5993 277.106 51.6993C280.806 62.8993 264.606 50.5993 262.206 48.8993C250.606 41.4993 239.006 35.2993 225.906 30.9993C155.906 9.99931 89.6057 47.8993 48.4057 107.099C31.5057 133.099 20.2057 160.499 11.0057 190.699C10.1057 193.999 9.2057 198.299 7.3057 201.199C5.5057 204.499 6.6057 192.399 6.6057 191.799C8.1057 179.299 10.7057 167.299 13.8057 155.199C32.9057 90.9993 74.9057 37.3993 135.306 12.7993ZM216.006 128.399C216.006 155.699 193.906 177.899 166.606 177.899C139.306 177.899 117.206 155.799 117.206 128.399C117.206 100.999 139.306 78.8993 166.606 78.8993C193.906 78.8993 216.006 100.999 216.006 128.399Z"
              fill="#003A9B"
            />
          </svg>
        ),
      });
    }
    // Limit to maximum 3 tags
    return tags.slice(0, 3);
  };

  const reformatJobsInFirebase = async () => {
    const querySnapshot = await getDocs(
      query(collection(db, "Jobs"), where("linkedin", "==", true))
    );
    querySnapshot.forEach(async (doc) => {
      const job = doc.data();
      const updatedJob = {
        ...job,
        id: job.id.toString(),
        locationRestrictions:
          job.locationRestrictions !== "none" ? [job.locationRestrictions] : [],
        categories: job.categories !== "none" ? [job.categories] : [],
        seniority: job.seniority !== "none" ? [job.seniority] : [],
      };
      await updateDoc(doc.ref, updatedJob);
      console.log(`Updated job: ${job.id}`);
    });
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  };

  const fetchLinkedin = async () => {
    const countries = [
      "Argentina",
      "Brazil",
      "Peru",
      "Chile",
      "Uruguay",
      "Colombia",
      "Mexico",
    ];
    let allParsedJobs = [];

    const scrapeJobLink = async (url) => {
      try {
        const response = await fetch(
          `http://api.scraperapi.com?api_key=40e835835e15e077889d3a6050018e3e&url=${encodeURIComponent(
            url
          )}`
        );
        const html = await response.text();
        console.log("HTML scraped:", html.slice(0, 100)); // Log the first 100 characters of the HTML
        return html;
      } catch (error) {
        console.error("Error scraping job link:", error);
        return null;
      }
    };

    const parseJobHtml = async (html, url, pub) => {
      const parser = new DOMParser();
      const doclinny = parser.parseFromString(html, "text/html");

      // Extracting fields
      const applyUrlElement = doclinny.querySelector("#applyUrl");
      const applyUrlContent = applyUrlElement
        ? applyUrlElement.innerHTML.trim()
        : null;
      const applyNowLinkMatch = applyUrlContent
        ? applyUrlContent.match(/"([^"]+)"/)
        : null;
      let applyNowLink =
        applyNowLinkMatch && applyNowLinkMatch[1]
          ? applyNowLinkMatch[1]
          : "none";

      // Extract the final URL from the redirect link
      if (applyNowLink !== "none") {
        const urlMatch = applyNowLink.match(/url=([^&]+)&?/);
        if (urlMatch && urlMatch[1]) {
          applyNowLink = decodeURIComponent(urlMatch[1]).split("?")[0]; // Remove query parameters
        }
      }

      const location =
        doclinny.querySelector(".sub-nav-cta__meta-text")?.textContent.trim() ||
        "none";
      const seniority =
        doclinny
          .querySelector(
            ".description__job-criteria-text.description__job-criteria-text--criteria"
          )
          ?.textContent.trim() || "none";
      const title =
        doclinny.querySelector("h3.sub-nav-cta__header")?.textContent.trim() ||
        "none";
      const companyName =
        doclinny
          .querySelector("a.sub-nav-cta__optional-url")
          ?.textContent.trim() || "none";
      const descriptionElement = doclinny.querySelector(
        ".show-more-less-html__markup.show-more-less-html__markup--clamp-after-5.relative.overflow-hidden"
      );
      const description = descriptionElement
        ? descriptionElement.innerHTML.trim()
        : "none";
      const companyLogo =
        doclinny
          .querySelector("img.sub-nav-cta__image")
          ?.getAttribute("data-delayed-url") || "none";
      const categories =
        doclinny
          .querySelectorAll(
            ".description__job-criteria-text.description__job-criteria-text--criteria"
          )[3]
          ?.textContent.trim() || "none";
      const idElement = doclinny.querySelector("#decoratedJobPostingId");
      const idContent = idElement ? idElement.innerHTML.trim() : null;
      const idMatch = idContent ? idContent.match(/"([^"]+)"/) : null;
      const hashCode = (s) =>
        s.split("").reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0);
      const id =
        typeof url === "string"
          ? hashCode(url)
          : idMatch && idMatch[1]
          ? idMatch[1]
          : "none";

      const locationArray = location !== "none" ? [location] : [];
      const categoriesArray = categories !== "none" ? [categories] : [];
      const seniorityArray = seniority !== "none" ? [seniority] : [];
      const idString = id.toString();

      let transformedJob = {
        applyNowLink: applyNowLink,
        categories: categoriesArray,
        companyLogo: companyLogo,
        companyName: companyName,
        description: description,
        pubDate: Math.floor(new Date(pub).getTime() / 1000),
        expiryDate: Math.floor(
          new Date(
            new Date(pub).getTime() + 21 * 24 * 60 * 60 * 1000
          ).getTime() / 1000
        ),
        guid: url,
        id: idString,
        locationRestrictions: locationArray,
        seniority: seniorityArray,
        title: title,
        linkedin: true,
      };

      console.log("Parsed job:", transformedJob);
      return transformedJob;
    };

    for (const country of countries) {
      let start = 0;
      let jobsFound = 0;
      while (jobsFound < 500) {
        const linkedinUrl = `https://www.linkedin.com/jobs-guest/jobs/api/seeMoreJobPostings/search?location=${country}&trk=public_jobs_jobs-search-bar_search-submit&start=${start}`;

        try {
          const html = await scrapeJobLink(linkedinUrl);
          const dock = new DOMParser().parseFromString(html, "text/html");
          const jobElements = Array.from(
            dock.querySelectorAll(".base-search-card__info")
          );

          if (jobElements.length === 0) {
            break;
          }

          const jobPromises = jobElements.map(async (el) => {
            const jobLink = el
              .closest(".base-card")
              .querySelector(".base-card__full-link")?.href;
            const pubDateElement = el
              .closest(".base-card")
              .querySelector("time.job-search-card__listdate");
            const pubDate = pubDateElement
              ? pubDateElement.getAttribute("datetime")
              : "none";

            if (jobLink) {
              const regexPattern = /jobs\/view\/.*-(\d+)\?/;
              const match = jobLink.match(regexPattern);
              if (match && match[1]) {
                const jobID = match[1];

                const transformedLink = `https://www.linkedin.com/jobs/view/${jobID}/`;

                // Scrape and parse the job HTML
                const jobHtml = await scrapeJobLink(transformedLink);
                if (jobHtml) {
                  const parsedJob = await parseJobHtml(
                    jobHtml,
                    transformedLink,
                    pubDate
                  );
                  if (parsedJob.applyNowLink !== "none") {
                    const jobRef = doc(db, "Jobs", parsedJob.id.toString());
                    const docSnap = await getDoc(jobRef);
                    if (!docSnap.exists()) {
                      try {
                        await setDoc(jobRef, parsedJob);
                        console.log(
                          "Job added to Firebase successfully:",
                          parsedJob.id
                        );
                      } catch (error) {
                        console.error("Error writing job to Firebase:", error);
                      }
                    } else {
                      console.log(
                        "Job already exists in Firebase:",
                        parsedJob.id
                      );
                    }
                  }
                }
              }
            }
          });

          const jobs = await Promise.all(jobPromises);
          allParsedJobs.push(...jobs.filter((job) => job));
          jobsFound += jobs.filter((job) => job).length;
        } catch (error) {
          console.error(
            "There was a problem with fetching LinkedIn jobs:",
            error
          );
        }
        start += 25;
      }
    }

    console.log("Finished adding jobs");
    return allParsedJobs;
  };

  return (
    <AnimatePresence layout="position">
      <motion.div
        className="w-1/2 shrink-0 flex flex-col items-start justify-start gap-[16px] text-left text-lg text-gray-700 font-text-l-regular overflow-y-auto h-screen"
        layout="position"
      >
        <motion.div className="self-stretch" layout="position">
          <JobBar
            openTags={() => setShowTags(true)}
            onSearch={setSearchInput}
            searchInput={searchInput}
            setFilters={setFilters}
            onTagSelect={(tag) => {
              setSearchInput("");
              setSelectedTags([...selectedTags, tag]);
            }}
            onTagRemove={(tagToRemove) => {
              setSelectedTags(
                selectedTags.filter((tag) => tag !== tagToRemove)
              );
            }}
            setResults={setResults}
            results={results}
            showFavoritesOnly={showFavoritesOnly}
            showUSOnly={showUSOnly}
            showRemoteOnly={showRemoteOnly}
            toggleShowFavoritesOnly={() =>
              setShowFavoritesOnly(!showFavoritesOnly)
            }
          />
          {/* <button onClick={fetchLinkedin} className="bg-red-400 px-4 py-4" /> */}
        </motion.div>
        <motion.div
          className="space-y-4 flex-grow overflow-y-auto w-full no-scrollbar"
          layout="position"
        >
          <AnimatePresence>
            {urlJob && (
              <motion.div
                key={urlJob.guid}
                layout="position"
                initial={{ opacity: 0, y: -5, scale: 0.9 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -5, scale: 0.9 }}
                transition={{
                  duration: 0.4,
                  ease: [0.43, 0.13, 0.23, 0.96],
                  exit: { duration: 0.2 },
                  delay: 0,
                }}
              >
                <JobContainer
                  active={true}
                  onSelect={() => {
                    setSelectedJob(urlJob);
                    console.log;
                  }}
                  job={urlJob}
                  position={urlJob.title}
                  pubDate={formatDate(urlJob.pubDate)}
                  company={urlJob.companyName}
                  categories={
                    Array.isArray(urlJob.categories)
                      ? urlJob.categories
                      : ["Not available"]
                  }
                  type={urlJob.type}
                  skills={Array.isArray(urlJob.skills) ? urlJob.skills : []}
                  seniority={urlJob.seniority || null}
                  location={
                    urlJob.locationRestrictions
                      ? Array.isArray(urlJob.locationRestrictions)
                        ? urlJob.locationRestrictions[0]
                        : urlJob.locationRestrictions
                      : "Remote"
                  }
                  tags={generateTags(urlJob)}
                  selected={selectedJob && selectedJob.guid === urlJob.guid}
                  guid={urlJob.guid}
                  maxSalary={
                    urlJob.maxSalary
                      ? `${urlJob.maxSalary.toLocaleString()}`
                      : null
                  }
                  source={urlJob.source}
                />
              </motion.div>
            )}
            {[
              ...new Map(
                results.filter((job) => job.type).map((job) => [job.guid, job])
              ).values(),
            ].map((job, index) => (
              <motion.div
                key={job.guid}
                layout="position"
                initial={{ opacity: 0, y: -5, scale: 0.9 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -5, scale: 0.9 }}
                transition={{
                  duration: 0.4,
                  ease: [0.43, 0.13, 0.23, 0.96],
                  exit: { duration: 0.2 },
                  delay: index < 10 ? index * 0.075 : 10 * 0.075,
                }}
              >
                <JobContainer
                  active={false}
                  onSelect={() => {
                    setSelectedJob(job);
                    console.log;
                  }}
                  position={job.title}
                  pubDate={formatDate(job.pubDate)}
                  company={job.companyName}
                  categories={
                    Array.isArray(job.categories)
                      ? job.categories
                      : ["Not available"]
                  }
                  type={job.type}
                  skills={Array.isArray(job.skills) ? job.skills : []}
                  seniority={job.seniority || null}
                  location={
                    job.locationRestrictions
                      ? Array.isArray(job.locationRestrictions)
                        ? job.locationRestrictions[0]
                        : job.locationRestrictions
                      : "Remote"
                  }
                  tags={generateTags(job)}
                  selected={selectedJob && selectedJob.guid === job.guid}
                  guid={job.guid}
                  maxSalary={
                    job.maxSalary ? `${job.maxSalary.toLocaleString()}` : null
                  }
                  source={job.source}
                />
              </motion.div>
            ))}
            <div className="h-8"></div>
          </AnimatePresence>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default React.memo(JobsContainer);
